import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconStart = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.0471 10.3138C19.3176 11.194 19.3176 13.0561 18.0471 13.9362L9.51518 19.8465L8.90832 18.9886L9.51518 19.8465C8.03451 20.8722 6 19.8239 6 18.0353L6 6.21468C6 4.42606 8.03451 3.37779 9.51518 4.4035L18.0471 10.3138ZM16.8334 12.2203C16.9003 12.174 16.9003 12.076 16.8334 12.0297L8.30147 6.11936C8.27371 6.10013 8.25502 6.09697 8.24224 6.09639C8.22549 6.09564 8.20315 6.09941 8.17974 6.11147C8.15633 6.12354 8.14039 6.13948 8.13142 6.15349C8.12456 6.16419 8.11646 6.18115 8.11646 6.21468L8.11646 18.0353C8.11646 18.0688 8.12456 18.0858 8.13141 18.0965C8.14039 18.1105 8.15633 18.1265 8.17974 18.1385C8.20315 18.1506 8.22549 18.1544 8.24224 18.1536C8.25502 18.153 8.27371 18.1499 8.30147 18.1306L16.8334 12.2203Z"
        />
      </svg>
    );
  }
);
